module.exports = __webpack_public_path__ + "@/assets/img/pdf.d74a9f95.svg";